export default "__VITE_ASSET__DFTkqNnF__"